/**
 * PSTUDIO-3992 — the "Auto-renumber pasted nodes" tooltip TITLE must reflect the
 * toggle's state. The tooltip body already described Smart vs Raw, but the title
 * read identically in both states, so the control looked stateless.
 *
 * Kept as a pure helper (mirrors group-color.ts) because this package has no
 * React testing library: the conditional text is unit-tested here, and the
 * wiring is covered by the clipboard e2e.
 */
export function autoRenumberToggleTitle(
  enabled: boolean,
  shortcut: string
): string {
  return `Auto-renumber pasted nodes: ${enabled ? 'On' : 'Off'} (${shortcut})`;
}
